import { render, staticRenderFns } from "./SidebarSarpras.vue?vue&type=template&id=5d72b187&"
import script from "./SidebarSarpras.vue?vue&type=script&lang=js&"
export * from "./SidebarSarpras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports